var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { ref: "stepForm", attrs: { model: _vm.formData, rules: _vm.rules } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { staticClass: "form-step-title", attrs: { span: 24 } },
            [
              _c("div", { staticClass: "steptitle" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.stepTitle) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _vm.formData["sameAsApplicant"] !== undefined
                ? _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.formData["sameAsApplicant"],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "sameAsApplicant", $$v)
                        },
                        expression: "formData['sameAsApplicant']",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Same as applicant details\n                "
                      ),
                    ]
                  )
                : _c("div", [_vm._v("\n \n                ")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.value, function (val, field, j) {
            return _c(
              "el-col",
              { key: "validation_g" + j },
              [
                field == "gender"
                  ? _c("el-form-item", { attrs: { prop: field } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "mr" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Mr.\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "mrs" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Mrs.\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "ms" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Ms.\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.value, function (val, field, i) {
            return _c(
              "el-col",
              { key: "validation" + i, attrs: { sm: 24, md: 12 } },
              [
                field == "applying_as"
                  ? _c("el-form-item", { attrs: { prop: field } }, [
                      _c("label", { staticClass: "el-form--label-top" }, [
                        _vm._v(
                          _vm._s(
                            _vm.__("fieldnames." + _vm.formName + "." + field)
                          ) + "*\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "architect_name" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Architect\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "client" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Client\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "contractor" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Contractor\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "associate_architect" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Associate Architect\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "other" },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Other\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : field == "sameAsApplicant"
                  ? _c("div")
                  : field == "newsletter"
                  ? _c("el-form-item", { attrs: { prop: field } }, [
                      _c("label", { staticClass: "el-form--label-top" }, [
                        _vm._v(
                          _vm._s(
                            _vm.__("fieldnames." + _vm.formName + "." + field)
                          ) + "*\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Yes\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 0 },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            No\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : field == "country"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            options: _vm.countryOptions,
                            "field-type": "select",
                            required: _vm.rules[field][0].required,
                            disabled: _vm.isSame,
                            "form-name": _vm.formName,
                            "form-step": _vm.step,
                          },
                          on: {
                            change: function ($event) {
                              _vm.formData.state_region = ""
                            },
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : field == "state_region"
                  ? [
                      _vm.currentStateOptions != {} &&
                      _vm.currentStateOptions.length != 0
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: field } },
                            [
                              _c("InputWh", {
                                attrs: {
                                  placeholder: field,
                                  options: _vm.currentStateOptions,
                                  "field-type": "select",
                                  required: _vm.rules[field][0].required,
                                  disabled: _vm.isSame,
                                  "form-name": _vm.formName,
                                  "form-step": _vm.step,
                                },
                                model: {
                                  value: _vm.formData[field],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, field, $$v)
                                  },
                                  expression: "formData[field]",
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "emptyfield" }, [
                            _vm._v("\n \n                    "),
                          ]),
                    ]
                  : field == "category"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            options: _vm.categoryOptions,
                            "field-type": "select",
                            required: _vm.rules[field][0].required,
                            "form-name": _vm.formName,
                            "form-step": _vm.step,
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : field == "year_of_production"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            options: _vm.yearOptions,
                            "field-type": "select",
                            required: _vm.rules[field][0].required,
                            "form-name": _vm.formName,
                            "form-step": _vm.step,
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : field == "phone_number"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("vue-tel-input", {
                          attrs: {
                            "default-country": "US",
                            "valid-characters-only": "",
                            "input-options": {
                              showDialCode: true,
                              tabindex: 0,
                            },
                            required: _vm.rules[field][0].required,
                            disabled: _vm.isSame,
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                field != "gender" &&
                field != "newsletter" &&
                field != "phone_number" &&
                field != "applying_as" &&
                field != "project_description" &&
                field != "floorplans" &&
                field != "video_link" &&
                field != "images" &&
                field != "year_of_production" &&
                field != "category" &&
                field != "subcategory" &&
                field != "state_region" &&
                field != "country" &&
                field != "sameAsApplicant"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            disabled: field != "vat_id" ? _vm.isSame : false,
                            "form-name": _vm.formName,
                            "form-step": _vm.step,
                            required: _vm.rules[field][0].required,
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.step == 5
        ? _vm._l(_vm.value, function (val, field, k) {
            return _c(
              "el-row",
              { key: "validation_f" + k, attrs: { gutter: 15 } },
              [
                field == "video_link"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("InputWh", {
                          attrs: {
                            placeholder: field,
                            disabled: field != "vat_id" ? _vm.isSame : false,
                            "form-name": _vm.formName,
                            "form-step": _vm.step,
                            required: _vm.rules[field][0].required,
                          },
                          model: {
                            value: _vm.formData[field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, field, $$v)
                            },
                            expression: "formData[field]",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                field == "images"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("el-form-item", [
                          _c("div", { staticClass: "form-step-title" }, [
                            _c("div", { staticClass: "steptitle" }, [
                              _c("b", [
                                _vm._v(
                                  "Project Images - Floorplans and Elevations Pdf"
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-pretext" }, [
                            _vm._v(
                              "\n                            The next three steps are essential for your project application. Images, floorplans, and elevations will be used for the jury review.\n                            Your project text description will be used on our websites, publications, and exhibition materials. Please submit content and images during \n                            your application that accurately represent your project. "
                            ),
                            _c("b", [_vm._v("All steps are mandatory")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-heading" }, [
                          _vm._v(
                            "\n                        Project Images Upload *\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload-pretext" }, [
                          _c("div", { staticStyle: { color: "#f39200" } }, [
                            _c("b", [
                              _vm._v(
                                "Drop files or click here to upload 12 to 15 images"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _c("b", [_vm._v("1. ASPECT RATIO 16:9")]),
                          _vm._v(
                            "\n                        (1920px Χ 1080px Landscape or Portrait). "
                          ),
                          _c("br"),
                          _c("b", [_vm._v("2. ASPECT RATIO 1:1")]),
                          _vm._v(
                            "\n                        (1080px X 1080px Square format). You can upload images\n                        in mixed formats. "
                          ),
                          _c("br"),
                          _c("b", [_vm._v("3. RESOLUTION:")]),
                          _vm._v(
                            "\n                        300dpi/image, max 6MB per file. The file names should\n                        use explicitly Latin characters. (Please upload 12-15\n                        images) "
                          ),
                          _c("br"),
                          _c("b", [_vm._v("4. FILE TYPE:")]),
                          _vm._v(
                            "\n                        JPG, PNG.\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-upload",
                          {
                            ref: "uploader",
                            refInFor: true,
                            attrs: {
                              action:
                                "https://jsonplaceholder.typicode.com/posts/",
                              multiple: true,
                              drag: true,
                              "on-change": _vm.handleChange,
                              "on-remove": _vm.handleRemove,
                              "file-list": _vm.formData.images,
                              "auto-upload": false,
                              "list-type": "picture",
                            },
                          },
                          [
                            _c("div", { staticClass: "el-upload__text" }, [
                              _vm._v(
                                "\n                            Drop files or click here to upload\n                            "
                              ),
                              _c("em", [_vm._v("12 - 15 images")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-icon" }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "el-form-item__error" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.filesError) +
                              "\n                    "
                          ),
                        ]),
                      ],
                      1
                    )
                  : field == "floorplans"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: field } },
                      [
                        _c("div", { staticClass: "field-heading" }, [
                          _vm._v(
                            "\n                        Project Floorplans and Elevations Upload *\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload-pretext" }, [
                          _c("div", { staticStyle: { color: "#f39200" } }, [
                            _c("b", [
                              _vm._v(
                                "Drop pdf or click here to upload up to 1pdf file with all plans and Elevation plans"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _c("b", [_vm._v("1. FILE SIZE:")]),
                          _vm._v(
                            "\n                        Max 25mb\n                        "
                          ),
                          _c("b", [_vm._v("2. FILE TYPE:")]),
                          _vm._v(
                            "\n                        PDF format.\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-upload",
                          {
                            ref: "floorplansuploader",
                            refInFor: true,
                            attrs: {
                              accept: "application/pdf",
                              action:
                                "https://jsonplaceholder.typicode.com/posts/",
                              multiple: false,
                              limit: 1,
                              drag: true,
                              "on-change": _vm.handleChangeFloorPlansPDF,
                              "on-remove": _vm.handleRemoveFloorPlans,
                              "file-list": _vm.formData.floorplans,
                              "auto-upload": false,
                            },
                          },
                          [
                            _c("div", { staticClass: "el-upload__text" }, [
                              _vm._v(
                                "\n                            Drop pdf or click here to upload\n                            "
                              ),
                              _c("em", [_vm._v("up to 1 pdf file")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-icon" }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload-aftertext" }, [
                          _c("b", [_vm._v("Notice:")]),
                          _vm._v(
                            " Please upload Plans/Sections/Elevations or blueprints, for the jury procedure. \n                        For more images for the jury procedure or 3d renderings and plans please forward directly to us using a public folder in dropbox at "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "mailto:curatorial@chi-athenaeum.org",
                              },
                            },
                            [_vm._v("curatorial@chi-athenaeum.org")]
                          ),
                          _c("br"),
                          _c("br"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "el-form-item__error" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.filesError) +
                              "\n                    "
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        _vm._l(_vm.value, function (val, field, j) {
          return _c(
            "el-col",
            { key: "validation_pd" + j },
            [
              field == "project_description"
                ? _c("el-form-item", { attrs: { prop: field } }, [
                    _c(
                      "div",
                      { staticClass: "projectdesc" },
                      [
                        _c("div", { staticClass: "field-heading" }, [
                          _vm._v(
                            "\n                            Project Description (1000 words max)*\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: field } },
                          [
                            _c("InputWh", {
                              attrs: {
                                placeholder: field,
                                "field-type": "textarea",
                                required: _vm.rules[field][0].required,
                                "form-name": _vm.formName,
                                "form-step": _vm.step,
                              },
                              model: {
                                value: _vm.formData[field],
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, field, $$v)
                                },
                                expression: "formData[field]",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "message-counter" }, [
                              _vm._v(
                                _vm._s(_vm.formData[field].length) +
                                  " /\n                                "
                              ),
                              _c(
                                "span",
                                {
                                  style: [
                                    _vm.formData[field].length < 5000
                                      ? { color: "green" }
                                      : { color: "red" },
                                  ],
                                },
                                [_vm._v("5000")]
                              ),
                              _vm._v(
                                "\n                                max characters"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-aftertext" }, [
                      _c("b", [_vm._v("Notice:")]),
                      _vm._v(
                        " Please paste your project description text in the box bellow. Description should not extend the 1000 words and it should represent your project describing the idea and all the technical details. We will use part or all of your text for all the website presentations, exhibition materials,publications and social media.\n                    "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-buttons" },
        [
          _vm.step > 0
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    size: "medium",
                    icon: "el-icon-arrow-left",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("prevStep")
                    },
                  },
                },
                [_vm._v("\n                Back\n            ")]
              )
            : _c("div", [_vm._v("\n \n            ")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.handleNextStep()
                },
              },
            },
            [_vm._v("\n                Next\n            ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }